import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DriverAutocompleteComponent } from './driver-autocomplete.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { FieldErrorMessagesModule } from '../field-error-messages/field-error-messages.module';
import { DirectivesModule } from '../../common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [DriverAutocompleteComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSelectModule,
    FieldErrorMessagesModule,
    DirectivesModule,
    SvgIconModule,
  ],
  exports: [DriverAutocompleteComponent],
})
export class DriverAutocompleteModule {}
